import { useMemo } from "react";
import { useSelector } from "react-redux";
import searchForTab from "common/searchTab";

import tabs from "assets/json/tabs.json";

const useTab = (path, wholeTab = false) => {
	const address = useSelector(state => state.window.currentAddress);
	const tabId = useMemo(() => {
		const splittedPath = path.split(".");
		const splittedAddress = address.replace(/~[^.]+(?=\.|$)/g, "").split(".");

		// ie. redirect("") -> redirects to the top of the tree
		if (splittedPath.length === 1 && splittedPath[0] === "") {
			return splittedAddress[0];
		}

		// Not that deep in the tree -> null is returned
		if (splittedAddress.length <= splittedPath.length) {
			return null;
		}

		let flag = true;
		while (splittedPath.length > 0) {
			if (splittedPath[0] !== splittedAddress[0] && splittedPath[0] !== "*") {
				flag = false;
				break;
			}

			splittedPath.shift();
			splittedAddress.shift();
		}

		if (!flag) {
			return null;
		}

		return splittedAddress[0];
	}, [path, address]);

	const tab = useMemo(() => {
		if (!wholeTab) return;
		if (!tabId) {
			return null;
		}

		let t;
		if (path === "") {
			t = searchForTab(tabs, tabId);
		} else {
			let correctPath = path;
			if (path.includes("*")) {
				const splittedPath = path.split(".");
				const splittedAddress = address.split(".");
				correctPath = splittedPath
					.map((string, index) => {
						return string === "*" ? splittedAddress[index] : string;
					})
					.join(".");
			}

			t = searchForTab(tabs, `${correctPath}.${tabId}`);
		}

		return t;
	}, [tabId, wholeTab, path, address]);

	return (wholeTab ? tab : tabId) || null;
};

const useTabNew = (path, options, wholeTab = false) => {
	const address = useSelector(options.addressState);

	const tabId = useMemo(() => {
		const splittedPath = path.split(".");
		const splittedAddress = address.replace(/~[^.]+(?=\.|$)/g, "").split(".");

		// ie. redirect("") -> redirects to the top of the tree
		if (splittedPath.length === 1 && splittedPath[0] === "") {
			return splittedAddress[0];
		}

		// Not that deep in the tree -> null is returned
		if (splittedAddress.length <= splittedPath.length) {
			return null;
		}

		let flag = true;
		while (splittedPath.length > 0) {
			if (splittedPath[0] !== splittedAddress[0] && splittedPath[0] !== "*") {
				flag = false;
				break;
			}

			splittedPath.shift();
			splittedAddress.shift();
		}

		if (!flag) {
			return null;
		}

		return splittedAddress[0];
	}, [path, address]);

	const tab = useMemo(() => {
		if (!tabId || !wholeTab) return null;

		let t;
		if (path === "") {
			t = searchForTab(options.tabs, tabId);
		} else {
			let correctPath = path;
			if (path.includes("*")) {
				const splittedPath = path.split(".");
				const splittedAddress = address.split(".");
				correctPath = splittedPath
					.map((string, index) => {
						return string === "*" ? splittedAddress[index] : string;
					})
					.join(".");
			}

			t = searchForTab(options.tabs, `${correctPath}.${tabId}`);
		}

		return t;
	}, [tabId, wholeTab, path, address, options.tabs]);

	return (wholeTab ? tab : tabId) || null;
};

export { useTabNew };
export default useTab;
